<template>
  <div class="admin-layout">
    <!-- 侧边栏 -->
    <Sidebar :collapsed="sidebarCollapsed" @toggle="toggleSidebar" />
    
    <!-- 主内容区 -->
    <div class="main-container" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <!-- 顶部栏 -->
      <Header @toggle-sidebar="toggleSidebar" />
      
      <!-- 内容区域 -->
      <div class="content-wrapper">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import Sidebar from '@/components/Sidebar.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'AdminLayout',
  components: {
    Sidebar,
    Header
  },
  setup() {
    const sidebarCollapsed = ref(false)
    
    const toggleSidebar = () => {
      sidebarCollapsed.value = !sidebarCollapsed.value
    }
    
    return {
      sidebarCollapsed,
      toggleSidebar
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f5f7fa;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 280px; // 侧边栏宽度   需要和Sidebar.vue中一致
  // Sidebar 使用 position: fixed 脱离文档流，此处如果仅用 flex:1 会导致 main-container 仍占满 100% 宽度，
  // 再叠加 margin-left 会让整体超出视口宽度，窄屏/Windows 150% 缩放时右侧内容（Header 按钮、表格 fixed 列）会被裁剪看不到。
  width: calc(100% - 280px);
  transition: margin-left 0.3s ease;
  
  &.sidebar-collapsed {
    margin-left: 80px; // 折叠后的侧边栏宽度
    width: calc(100% - 80px);
  }
}

.content-wrapper {
  flex: 1;
  min-height: 0; // 确保 flex 子元素可以缩小
  // 使用 scroll 而不是 auto，确保滚动条始终显示，避免宽度变化
  overflow-y: scroll;
  overflow-x: auto; // 允许横向滚动，避免表格等宽内容被裁剪
  padding: 20px;
  background: #f5f7fa;
}
</style>

